<template>
  <div data-test="charge-type-state 1">
    <pricing-period-dated
      v-show="isAvailable || isDisabled"
      :price="chargetype.price"
    />
    <div
      v-show="!(isAvailable || isDisabled) && !alternativeStays.loading.value"
      class="pt-status-msg ct-status-msg"
      :class="{
        'other-dates': alternativeStays.data.value.length,
      }"
    >
      <img src="@/assets/images/warning.svg" width="15" height="15" alt="" />
      <translate
        v-if="isMinNights || chargetype.availAfterMinStay"
        :tt="{ minDays: chargetype.minDays }"
      >
        Min. {minDays} nights
      </translate>
      <translate
        v-else-if="isMaxCapacity && !chargetype.isOvercapacityMessage"
        :tt="{ maxPersons: pitchtype.maxPersons }"
      >
        Max. persons ({maxPersons})
      </translate>
      <!-- 'Party size restricted' -->
      <span v-else-if="chargetype.isOvercapacityMessage">
        {{ chargetype.isOvercapacityMessage }}
      </span>
      <translate v-else-if="isAdultsOnly"> Adults only </translate>
      <translate v-else-if="alternativeStays.data.value.length">
        Other dates available
      </translate>
      <translate v-else data-test="no-availability-on-our-site-2">
        No availability on our site
      </translate>
    </div>
  </div>
</template>

<script lang="ts">
import { ComputedRef } from 'vue'
import {
  Component,
  Inject,
  Prop,
  Vue,
  toNative,
} from '~/utility/pu-class-decorator'
import { CalendarDay } from '../../../../campsite-details/alternativeStaysFetch'
import { ChargeType } from '../../../../campsite-details/types'
import { PitchTypeWithChargeType } from '../../../types'

@Component
class ChargeTypeState extends Vue {
  @Prop()
  pitchtype: PitchTypeWithChargeType

  @Inject({ from: 'alternativeStays' }) alternativeStays: {
    data: ComputedRef<CalendarDay[]>
    loading: ComputedRef<boolean>
    error: ComputedRef<Error | null>
  }

  get chargetype(): ChargeType {
    return this.pitchtype.chargetype
  }

  get isAvailable() {
    return this.chargetype.state === 'available'
  }

  get isDisabled() {
    return this.chargetype.state === 'disabled'
  }

  get isMinNights() {
    return this.chargetype.state === 'min_nights'
  }

  get isMaxCapacity() {
    return this.chargetype.state === 'max_capacity'
  }

  get isAdultsOnly() {
    return this.chargetype.state === 'adults_only'
  }
}

export default toNative(ChargeTypeState)
</script>
